import PropTypes from 'prop-types';

const MobileBlueIcon = ({ className = '' }) => (
  <svg
    width="41"
    height="61"
    viewBox="0 0 41 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect y="46.7617" width="41" height="14" fill="#0A0777" />
    <rect y="0.761719" width="41" height="9" fill="#0A0777" />
    <rect y="9.76172" width="41" height="37" fill="#C9E3F7" />
    <circle cx="20.5" cy="53.7617" r="3" fill="#C9E3F7" />
  </svg>
);

MobileBlueIcon.propTypes = {
  className: PropTypes.string
};

export default MobileBlueIcon;
